/**
 * @name: stylePatch
 * @Author: HZQ
 * @Date: 2024/1/15 11:17
 * @Description: 2024/1/15 11:17
 * @Version: 1.0
 */
export function stylePatch (style) {
  const replacementString = '.el-checkbox-button.is-disabled.is-checked .el-checkbox-button__inner{background-color: #f2f6fc;}.el-checkbox-button.is-disabled:first-child .el-checkbox-button__inner'
  style = style.replace(/\.el-checkbox-button\.is-disabled:first-child \.el-checkbox-button__inner/, replacementString)
  return style
}



// WEBPACK FOOTER //
// ./src/utils/stylePatch.js